import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-block-item-create-account',
  templateUrl: './block-item-create-account.component.html',
  styleUrls: ['./block-item-create-account.component.scss']
})
export class BlockItemCreateAccountComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
